/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseTextField
 */
export interface DatabaseTextField extends DatabaseField {
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextField
     */
    defaultTextValue?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseTextField
     */
    maxLength?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseTextField
     */
    formatted?: boolean;
    /**
     * number of rows to display for multiline text input (1-10, autosize if not set)
     * @type {number}
     * @memberof DatabaseTextField
     */
    numRows?: number;
}

/**
 * Check if a given object implements the DatabaseTextField interface.
 */
export function instanceOfDatabaseTextField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTextFieldFromJSON(json: any): DatabaseTextField {
    return DatabaseTextFieldFromJSONTyped(json, false);
}

export function DatabaseTextFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTextField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'defaultTextValue': !exists(json, 'defaultTextValue') ? undefined : json['defaultTextValue'],
        'maxLength': !exists(json, 'maxLength') ? undefined : json['maxLength'],
        'formatted': !exists(json, 'formatted') ? undefined : json['formatted'],
        'numRows': !exists(json, 'numRows') ? undefined : json['numRows'],
    };
}

export function DatabaseTextFieldToJSON(value?: DatabaseTextField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'defaultTextValue': value.defaultTextValue,
        'maxLength': value.maxLength,
        'formatted': value.formatted,
        'numRows': value.numRows,
    };
}

